<template>
  <div class="gift-animation-container" v-if="show">
    <!-- 遮罩层 -->
    <div class="mask" :class="{ 'mask-fade-out': isAnimationComplete }"></div>
    <div class="halo_wrapper">
      <!-- 光晕背景图 -->
      <div
        class="star-bg"
        :class="{
          'gift-scale': isFirstStage
        }"
        :style="{
          background: 'url(' + haloBackgroundImage + ') no-repeat center',
          'background-size': '100% 100%'
        }"
      ></div>
      <!-- 星星背景图 -->
      <div
        class="star-bg"
        :class="{
          'star-bg-grow': isFirstStage,
          'star-bg-pulse': isSecondStage
        }"
        :style="{
          background: 'url(' + starBackgroundImage + ') no-repeat center',
          'background-size': '100% 100%'
        }"
      ></div>
    </div>

    <!-- 礼盒容器 -->
    <div
      class="gift-wrapper flex ai-c jc-sb"
      :class="{
        'gift-scale': isFirstStage,
        'gift-fade-out': isThirdStage
      }"
    >
      <!-- 礼盒底部 -->
      <div
        class="gift-box"
        :style="{
          background: 'url(' + box + ') no-repeat center',
          'background-size': '100% 100%'
        }"
      ></div>

      <!-- 礼盒盖子 -->
      <div
        class="gift-lid"
        :class="{ 'lid-open': isSecondStage }"
        :style="{
          background: 'url(' + lid + ') no-repeat center',
          'background-size': '100% 100%'
        }"
      ></div>
    </div>

    <!-- 盲盒结果图 -->
    <div
      class="result-image"
      :class="{
        'result-appear': isThirdStage,
        'result-pulse': isFourthStage
      }"
      :style="{
        backgroundImage: `url(${result.img_path})`
      }"
    >
      <img
        class="w-50 pos-a l0 r0 m-auto"
        style="bottom: 8%"
        :src="'/static/images/blindBoxPop/btn_' + (result.qrcode_link ? '1' : '2') + '.png'"
        alt=""
        @click="resultHandle"
      />
      <p
        v-if="isTextShow"
        class="f15 color-F pos-a l0 r0 ml25 mr25"
        style="bottom: -18%"
        :class="{ 'ta-c': result.draw_num <= 0 }"
      >
        {{
          result.draw_num > 0
            ? '十周年盲盒抽奖，每人下单可解锁' +
              result.all_num +
              '次机会。订单若退款，奖品同步收回且机会不予补发。'
            : '十周年盲盒抽奖机会已用完。'
        }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StarBackgroundGiftBox',
  props: {
    // 礼盒
    box: {
      type: String,
      default: '/static/images/blindBoxPop/gift_1.png'
    },
    // 礼盒盖子
    lid: {
      type: String,
      default: '/static/images/blindBoxPop/gift_2.png'
    },
    // 光晕背景图URL
    haloBackgroundImage: {
      type: String,
      default: '/static/images/blindBoxPop/halo.png'
    },
    // 星星背景图URL
    starBackgroundImage: {
      type: String,
      default: '/static/images/blindBoxPop/star.png'
    },
    // 结果
    result: {
      type: Object,
      default: function () {
        return {}
      }
    },
    // 各阶段动画时长(毫秒)
    stageDuration: {
      type: Number,
      default: 1000
    },
    // 是否点击遮罩关闭
    maskClosable: {
      type: Boolean,
      default: false
    },
    // 是否自动开始动画
    autoStart: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      show: false,
      // 动画阶段控制
      isFirstStage: false, // 第一阶段：放大缩小动画
      isSecondStage: false, // 第二阶段：盖子打开
      isThirdStage: false, // 第三阶段：显示结果图
      isFourthStage: false, // 第四阶段：结果图缩放
      isTextShow: false // 是否显示结果文字
    }
  },
  watch: {
    // 当显示状态变化时重置或开始动画
    show(newVal) {
      if (newVal) {
        this.resetAnimation()
        if (this.autoStart) {
          this.startAnimation()
        }
      }
    }
  },
  methods: {
    open() {
      this.show = true
    },
    // 开始动画
    startAnimation() {
      this.isFirstStage = true
      // 动画阶段控制
      setTimeout(() => {
        // 第一阶段结束
        this.isFirstStage = false
        this.isSecondStage = true

        setTimeout(() => {
          // 第二阶段结束（礼盒打开动画完成）
          this.isSecondStage = false
          // 先让礼盒开始消失
          this.isThirdStage = true

          // 等待1秒后再显示结果图
          setTimeout(() => {
            // 礼盒已消失，开始显示结果图
            this.isFourthStage = true
            this.isTextShow = true
          }, 1000) // 礼盒消失动画持续1秒
        }, this.stageDuration) // 第二阶段（打开礼盒）持续时间
      }, this.stageDuration) // 第一阶段持续时间
    },

    // 重置动画
    resetAnimation() {
      this.isFirstStage = false
      this.isSecondStage = false
      this.isThirdStage = false
      this.isFourthStage = false
      this.isTextShow = false
      this.isAnimationComplete = false
    },
    resultHandle() {
      if (this.result.qrcode_link) {
        this.$app.argStaticLink(this.result.qrcode_link)
      } else {
        this.$emit('resultHandle')
      }
    }
  }
}
</script>

<style scoped>
.gift-animation-container {
  position: relative;
  z-index: 2001;
}
/* 遮罩层样式 - 黑色透明度0.4 */
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
  transition: opacity 0.5s ease;
}

.mask-fade-out {
  opacity: 0;
  pointer-events: none;
}
.halo_wrapper {
  width: 100%;
  height: 4.68rem;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

/* 礼盒容器样式 */
.gift-wrapper {
  width: 2rem;
  height: 2rem;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

/* 第一阶段：礼盒放大缩小动画 */
.gift-scale {
  animation: scaleAnimation 1s ease-in-out;
}

/* 第三阶段：礼盒消失 */
.gift-fade-out {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0);
  transition: all 1s ease;
}

/* 星星背景图样式 */
.star-bg {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  transform: translate(-50%, -50%);
  z-index: 1;
  opacity: 1;
}

/* 星星背景图第一阶段动画：由小变大 */
.star-bg-grow {
  animation: starGrow 1s ease-out forwards;
}

/* 星星背景图第二阶段动画：透明度0-1-0切换 */
.star-bg-pulse {
  animation: starPulse 1s ease-in-out infinite;
}
.box {
  position: absolute;
}

/* 礼盒底部样式 */
.gift-box {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 2rem;
  height: 1.7rem;
  z-index: 2;
}

/* 礼盒盖子样式 */
.gift-lid {
  position: absolute;
  top: 0;
  left: 0;
  width: 2rem;
  height: 1.15rem;
  transition: transform 1s ease-in-out;
  z-index: 3;
}

/* 盖子打开动画：垂直向上移动 */
.lid-open {
  transform: translateY(-50%);
}

/* 结果图片样式 */
.result-image {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background-size: cover;
  background-position: center;
  z-index: 1000;
  transform: translate(-50%, -50%);
  transition: width 1s ease-out, height 1s ease-out;
  opacity: 0;
}

/* 结果图弹出动画 */
.result-appear {
  opacity: 1;
  width: 3.2rem;
  height: 3.2rem;
}

/* 结果图缩放动画：先缩小再放大 */
.result-pulse {
  animation: resultPulse 1s ease-in-out;
}

/* 动画定义 */
@keyframes scaleAnimation {
  0% {
    transform: translate(-50%, -50%) scale(1);
  }
  25% {
    transform: translate(-50%, -50%) scale(1.15);
  }
  50% {
    transform: translate(-50%, -50%) scale(1);
  }
  75% {
    transform: translate(-50%, -50%) scale(1.15);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes starGrow {
  0% {
    transform: translate(-50%, -50%) scale(0.7);
    opacity: 0;
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}

@keyframes starPulse {
  0% {
    opacity: 0;
  }
  35% {
    opacity: 1;
  }
  70% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes resultPulse {
  0% {
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    transform: translate(-50%, -50%) scale(0.85);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/blindBoxPop.vue